<template>
  <section class="LandingSection s1">
    <article class="home-cover">
      <video playsinline autoplay muted loop id="video">
        <source src="@/assets/vid/home/OC-REEL4.mp4" type="video/mp4" />
      </video>
    </article>
    <article class="home-text">
      <div class="home-cta">
        <div class="title">
          <h1>ocular</h1>
          <img src="@/assets/gif/collective.gif" alt="" />
        </div>
        <p>Est. 2020, Bärn</p>
        <a href="#team" v-smooth-scroll
          ><button class="btn-big btn-border-white" v-smooth-scroll>
            mau dri luege
          </button></a
        >
      </div>
      <div class="socialmedia-icos">
        <div class="icon-wrapper">
          <a
            href="https://www.youtube.com/channel/UCvQGr0CuSC1dsMvwTPmr5FQ"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32.19"
              height="32.19"
              viewBox="0 0 32.19 32.19"
            >
              <path
                id="YT-icon"
                d="M16.095,0A16.095,16.095,0,1,0,32.19,16.095,16.095,16.095,0,0,0,16.095,0Zm7.588,16.555-11.34,6.567a.616.616,0,0,1-.313.083.625.625,0,0,1-.625-.625V9.491a.616.616,0,0,1,.092-.313.607.607,0,0,1,.846-.23L23.683,15.5a.552.552,0,0,1,.23.23.607.607,0,0,1-.23.828Z"
                fill="#ebebeb"
              />
            </svg>
          </a>
          <a href="https://www.instagram.com/ocular.ch/" target="_blank">
            <svg
              id="Gruppe_404"
              data-name="Gruppe 404"
              xmlns="http://www.w3.org/2000/svg"
              width="35.2"
              height="35.2"
              viewBox="0 0 35.25 35.25"
            >
              <path
                id="Pfad_653"
                data-name="Pfad 653"
                d="M104.567,90.667H93.756a3.092,3.092,0,0,0-3.089,3.089v10.811a3.092,3.092,0,0,0,3.089,3.089h10.811a3.092,3.092,0,0,0,3.089-3.089V93.756A3.092,3.092,0,0,0,104.567,90.667Zm-5.406,12.658a4.163,4.163,0,1,1,4.163-4.163A4.168,4.168,0,0,1,99.162,103.325Zm5.322-8.844a.7.7,0,1,1,.7-.7A.7.7,0,0,1,104.483,94.481Z"
                transform="translate(-81.534 -81.534)"
                fill="#f5f4f3"
              />
              <path
                id="Pfad_654"
                data-name="Pfad 654"
                d="M146.823,143.667a3.156,3.156,0,1,0,3.156,3.156A3.16,3.16,0,0,0,146.823,143.667Z"
                transform="translate(-129.196 -129.196)"
                fill="#f5f4f3"
              />
              <path
                id="Pfad_655"
                data-name="Pfad 655"
                d="M17.627,0A17.627,17.627,0,0,0,0,17.627c.928,23.382,34.329,23.375,35.254,0A17.627,17.627,0,0,0,17.627,0Zm9.5,23.033a4.1,4.1,0,0,1-4.1,4.1H12.221a4.1,4.1,0,0,1-4.1-4.1V12.221a4.1,4.1,0,0,1,4.1-4.1H23.033a4.1,4.1,0,0,1,4.1,4.1Z"
                fill="#f5f4f3"
              />
            </svg>
          </a>
          <a href="mailto:info@ocular.ch" target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32.25"
              height="32.25"
              viewBox="0 0 32.25 32.25"
            >
              <path
                id="mail"
                d="M16.125,0A16.125,16.125,0,1,0,32.25,16.125,16.114,16.114,0,0,0,16.125,0Zm7.812,21.734H9.815a1.9,1.9,0,0,1-1.9-1.9V12.519a1.818,1.818,0,0,1,.6-1.4h0a1.9,1.9,0,0,1,1.3-.5h12.72a2.109,2.109,0,0,1,1.3.5h0a1.977,1.977,0,0,1,.6,1.4v4.507a.5.5,0,1,1-1,0V12.519a.6.6,0,0,0-.1-.4l-6.21,4.707a1.819,1.819,0,0,1-2,0l-6.21-4.707c-.1.1-.1.2-.1.4v7.311a.9.9,0,0,0,.9.9H23.837a.473.473,0,0,1,.5.5C24.338,21.533,24.137,21.834,23.937,21.734Zm-8.213-5.609L9.815,11.618h12.62l-5.909,4.507A.606.606,0,0,1,15.724,16.125Z"
                fill="#ebebeb"
              />
            </svg>
          </a>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: "LandingSection",
};
</script>

<style lang="scss" scoped>
.LandingSection {
  display: flex;
  padding: 0;
  .home-cover {
    min-height: 100vh;
    width: 100%;
    background-size: cover;
    background-image: url("~@/assets/img/home/teambild_ocular-KLG.jpg");
    #video {
      width: 100%;
      height: 100vh;
      left: 0;
      position: absolute;
      object-fit: cover;
      object-position: center;
      z-index: 0;
    }
  }
  .home-text {
    margin-top: 10vh;
    height: 90vh;
    min-width: 100%;
    padding: 20vh 15vw 0 15vw;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    color: #f5f4f3;
    background-size: 50%;
    background-repeat: no-repeat;
    z-index: 1;
    .home-cta {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 50vh;
      width: 80vw;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 20vw;
          margin: 0 0 1.5vw 1vw;
        }
        h1 {
          font-family: canada-type-gibson, sans-serif;
          font-weight: 600;
          text-align: left;
          font-size: 4vw;
          letter-spacing: 0.5rem;
          line-height: 110%;
          color: #f5f4f3;
          margin: 0;
          width: 55%;
        }
      }
      p {
        font-size: 1vw;
        color: #f5f4f3;
        margin: -2vw 0 0 0.3vw;
      }
      a {
        padding-top: 3.5rem;
      }
      .btn-big {
        padding-top: 0.05rem;
      }
    }
    .socialmedia-icos {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 10vh;
      .icon-wrapper {
        display: flex;
        width: 15vw;
        justify-content: space-evenly;
        align-items: center;
        svg {
          width: 3.5rem;
          height: 3.5rem;
          circle {
            fill: #f5f4f3;
            transition: 0.3s;
          }
          path {
            fill: #f5f4f5;
            transition: 0.3s;
          }
          &:hover {
            path {
              fill: #1f2d35;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .LandingSection {
    .home-cover {
      width: 100%;
      background-size: cover;
      background-image: url("~@/assets/img/tn/jaru-nz.jpg");
      #video {
        width: 100%;
        left: 0;
        position: absolute;
        object-fit: cover;
        object-position: center;
        z-index: 0;
      }
    }
    .home-text {
      margin-top: 20vh;
      position: absolute;
      max-width: 100%;
      padding: 30vh 10vw 10vh 10vw;
      .home-cta {
        height: 30vh;
        text-align: left;
        .title {
          width: 100%;
          align-items: flex-start;
          justify-content: left;
          img {
            width: 45vw;
            margin: -2.8vw 0vw 0vw 3vw;
          }
          h1 {
            font-size: 7vw;
            margin-bottom: 1vh;
          }
        }
        h2 {
          font-size: 5vw;
        }
        p {
          font-size: 2rem;
        }
        a {
          padding-top: 3vw;
        }
      }
      .socialmedia-icos {
        justify-content: flex-start;
        margin-top: 10vh;
        .icon-wrapper {
          width: 80vw;
          justify-content: space-evenly;
          svg {
            width: 6vw;
            height: 6vw;
            &:hover {
              circle {
                fill: #1f2d35;
              }
              path {
                fill: #f5f4f3;
              }
            }
          }
        }
      }
    }
  }
}
</style>
